import EntityNotificationsClient from "./EntityNotificationsClient.js"

export default new EntityNotificationsClient()
